/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ConseillerPedagogiqueMetierLiesSearch
 */
export interface ConseillerPedagogiqueMetierLiesSearch {
    /**
     * 
     * @type {string}
     * @memberof ConseillerPedagogiqueMetierLiesSearch
     */
    idConseiller?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ConseillerPedagogiqueMetierLiesSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ConseillerPedagogiqueMetierLiesSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConseillerPedagogiqueMetierLiesSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ConseillerPedagogiqueMetierLiesSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ConseillerPedagogiqueMetierLiesSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConseillerPedagogiqueMetierLiesSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ConseillerPedagogiqueMetierLiesSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ConseillerPedagogiqueMetierLiesSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ConseillerPedagogiqueMetierLiesSearch interface.
 */
export function instanceOfConseillerPedagogiqueMetierLiesSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConseillerPedagogiqueMetierLiesSearchFromJSON(json: any): ConseillerPedagogiqueMetierLiesSearch {
    return ConseillerPedagogiqueMetierLiesSearchFromJSONTyped(json, false);
}

export function ConseillerPedagogiqueMetierLiesSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConseillerPedagogiqueMetierLiesSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idConseiller': !exists(json, 'idConseiller') ? undefined : json['idConseiller'],
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ConseillerPedagogiqueMetierLiesSearchToJSON(value?: ConseillerPedagogiqueMetierLiesSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idConseiller': value.idConseiller,
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

